import { render, staticRenderFns } from "./GaTable.vue?vue&type=template&id=ee861cca"
import script from "./GaTable.vue?vue&type=script&lang=ts"
export * from "./GaTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports